((ArticleProgress, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.blogPost = $('[data-blog-post]');
    $dom.currentProgress = $('[data-current-position]');
    $dom.mobileTransLinkHeader = $('.mobile-transformation-link-header');
  }
  
  const updateProgress = () => {
    const endBlog = $dom.blogPost.offset().top + $dom.blogPost.outerHeight();
    const scroll = $(window).scrollTop();
    const percentage = Math.floor(scroll / endBlog * 100) + '%';
    $dom.currentProgress.css('width', percentage);
  }

  const showArticleNav = () => {
    const scroll = $(window).scrollTop();
    const navHeight = $('header').height();
    const mobileTransLinkHeaderHeight = $dom.mobileTransLinkHeader.is(':visible') ? $dom.mobileTransLinkHeader.height() : 0;
    const countdownHeight = $('.countdown-banner').height();
    const totalHeight = navHeight + countdownHeight + mobileTransLinkHeaderHeight;

    if(scroll >= 50){
      $('.article-nav-header').addClass('open');
      $('.article-nav-header').css('top', totalHeight)
    }else{
      $('.article-nav-header').removeClass('open');
    }
  }

  const bindUIActions = () => {
    $(window).on('scroll', () => {
      updateProgress();
      showArticleNav();
    });
    $('.back-link').on('click', function(event){
      event.preventDefault();
      window.history.back();
    })
  };

  ArticleProgress.init = () => {
    cacheDom();
    updateProgress();
    bindUIActions();
  }

})(window.ArticleProgress = window.ArticleProgress || {}, jQuery);